import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TICKET_MODULE_NAMESPACE, TICKET_GET_TICKETS_SIDEBAR, TICKET_SET_TICKET_SIDEBAR, TICKET_RECORD_CHANNEL, TICKET_LOADERS, TICKET_SET_LOADER_STATE } from '../../../../store/ticket';
import { ITicketParameter, TicketParameter, ITicketListingViewModel, ITicketChannel } from '../../../../models/ticket';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { StateTypes } from '../../../../common/enums';
import { isNullOrUndefined } from 'util';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import * as _ from 'lodash';
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component({
  components: {
    'side-modal': async () => import('../ticket-sidebar-modal/TicketSideBarModal.vue'),
    'side-modal-add-participant': async () => import('../ticket-sidebar-modal-add-member/TicketSideBarAddParticipantModal.vue'),
    'sub-navigation-title': async () => import('@/components/sub-navigation-title/SubNavigationTitle.vue'),
    'ticket-sidebar-loader': async () => import('../../loaders/ticket-sidebar-loader/TicketSidebarLoader.vue')
  }
})
class TicketSideBarTicketGroups extends Vue {

  private _clearTimeout: any;
  dtMenu: boolean;
  dtSearchParam: ITicketParameter;
  dtModalVisible: boolean;
  dtModalAddParticipantVisible: boolean;
  dtChannel: any;
  dtRules: {
    nameRules?: any,
    participantsRules?: any
  }
  dtRecordChannelLoading: boolean;
  dtChannalRegistration: {
    name: string | null;
    participants: number[]
  }

  constructor() {
    super();
    this.dtMenu = false;
    this.dtModalVisible = false;
    this.dtChannel = null
    this.dtModalAddParticipantVisible = false;
    this.dtSearchParam = new TicketParameter({
      state: [StateTypes.Open, StateTypes.ReOpen, StateTypes.InProgress]

    })
    this.dtRecordChannelLoading = false;
    this.dtChannalRegistration = {
      name: null,
      participants: []
    }
  }
  @UserStore.Getter userInfo: { id: number, type: string };
  @TicketStore.Getter sideBarTickets: ITicketListingViewModel[];
  @TicketStore.Getter currentTicket: ITicketListingViewModel;
  @TicketStore.Getter currentChannel: ITicketChannel;
  @Watch('currentChannel')
  onCurrentChannelChange(newVal){
    if(this.coLoader) this.storeSetLoaderState({ key: TICKET_LOADERS.SIDEBAR, value: false })
  }
  @TicketStore.Getter loaders: Map<string,boolean>

  @TicketStore.Action(TICKET_GET_TICKETS_SIDEBAR)
  storeGetTickets: (payload: { param: ITicketParameter, ticketId: number }) => Promise<any>;

  @TicketStore.Action(TICKET_RECORD_CHANNEL)
  storeRecordChannel: (payload: { name: string, participants: number[] }) => Promise<any>;

  @TicketStore.Mutation(TICKET_SET_TICKET_SIDEBAR)
  storeSetCurrentTicket: (ticket: ITicketListingViewModel) => void;

  @TicketStore.Mutation(TICKET_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  get lblSetting() {
    return require('../../../../locales/button').default;

  }


  get currentChannelId(): number {
    const cID: number = parseInt(this.$route.params.cid);
    return isNaN(cID) ? null : cID;
  }
  get coTickets(): ITicketListingViewModel[] {
    return this.sideBarTickets;
  }
  get coCurrentTicket(): ITicketListingViewModel {
    return this.currentTicket;
  }
  set coCurrentTicket(value: ITicketListingViewModel) {
    this.storeSetCurrentTicket(value);
  }

  get isOwner(): boolean {
    return this.currentChannel.participants && this.currentChannel.participants.filter(x => x.entity.id === this.userInfo.id).length > 0
  }
  get coChannels(): { id: number, channelName: string, date: string }[] {
    const cns = (this.coCurrentTicket.channels || []).map(channel => {
      return {
        id: channel.id,
        channelName: channel.name,
        date: DateTimeHelper.parseDate(channel.updatedAt),
        unreadMessageNumber: this.getUnreadMessageNumber(channel, 'participants'),
        type: channel.type,
        participants: channel.participants
      };
    })

    return _.orderBy(cns, ['id'], ['asc'])
  }
  get coTicketSubject(): string {
    return this.currentTicket.subject;
  }

  get coUnreadMessageNumber(): number {
    /*const owner = this.currentTicket.managers.find(x => x.id === this.userInfo.id);
    if (owner) {
      return owner.actor.nb_message_unread;
    }*/
    if (this.currentTicket.nb_message_unread > 0)
      return this.currentTicket.nb_message_unread
    return 0;
  }


  get coCanAddParticipants(): boolean {
    return this.$route.meta.add_participant_channel && this.isOwner
  }

  get canCreateGroup(): boolean {
    let flag: number = 0
    if (this.currentTicket.channels) {
      return this.$route.meta.create_private_channel && this.currentTicket.channels.every(x => {
        if (x.participants === undefined) return false;
        flag += x.participants.filter(x => x['fk_actor_entity'] === this.userInfo.id).length;
        return flag > 0
      });
    }
    return false
  }
  get coLoader(): boolean {
    return this.loaders.get(TICKET_LOADERS.SIDEBAR)
  }

  getVisibility(channel: ITicketChannel) {
    return this.$route.meta.add_participant_channel && channel.id === this.currentChannelId
      && channel.participants.filter(x => x['fk_actor_entity'] === this.userInfo.id).length > 0;
  }
  getUnreadMessageNumber(target: any, type: string = 'managers'): number {
    if (target[type] === undefined) return 0;
    const owner = target[type].find(x => x.fk_actor_entity === this.userInfo.id);
    return owner ? owner.participant_channel.nb_message_unread : 0;
  }


  getUnreadForTicket(item) {
    /*if (item.managers) {
      const owner = item.managers.find(x => x.actor.fk_actor_entity === this.userInfo.id)
      if (owner) {
        return owner.actor.nb_message_unread
      }
    }*/
    if (item.nb_message_unread > 0)
      return item.nb_message_unread
    return 0;
  }

  handleTicketClick({ data, index }) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.coCurrentTicket = data;
      this.dtMenu = false;
      this.storeSetCurrentTicket(data);
      this.handleRedirectTo(data.channel_id, data.id);
    }, 300);
  }

  handleChannelClick(channel: { id: number }) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.handleRedirectTo(channel.id, this.coCurrentTicket.id)
    }, 300);
  }

  handleRedirectTo(channelId: number, ticketId: number) {
    setTimeout(() => this.$router.push({
      path: `/ticket/${ticketId}/channel/${channelId}`, params: {
        id: ticketId.toString(), cid: channelId.toString()
      }
    }), 300);

  }


  handleCreateNewGroup() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtModalVisible = true;
    }, 300);
  }
  handleSaveChannel() {
    this.dtRecordChannelLoading = true;
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeRecordChannel(this.dtChannalRegistration)
        .then(response => {
          this.dtChannalRegistration = { name: '', participants: [] };
          this.dtRecordChannelLoading = false;
          this.dtModalVisible = false;
          setTimeout(() => this.handleRedirectTo(response.id, response.fk_channel_ticket), 300);
        })
        .catch(error => {
          this.dtRecordChannelLoading = false;
        })
    }, 300);

  }
  get visible() {
    return parseInt(this.$route.params.cid) > 0;
  }
  handleGoBack() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => this.$router.push({ path: '/ticket' }), 100);
  }
  created() {
    this.handleGetTickets();
  }
  handleGetTickets() {
    const payload: any = { param: this.dtSearchParam };
    if (this.$route.params.id) {
      payload.ticketId === parseInt(this.$route.params.id);
    }

    this.storeSetLoaderState({ key: TICKET_LOADERS.SIDEBAR, value: true })
    this.storeGetTickets(payload)
      .catch(error => console.log(error))
  }
  mounted() {
    this.$watch('coTickets', (tickets) => {
      setTimeout(() => this.handleSetNewTicket(this.$route.params.id), 300);
    })
  }
  handleSetNewTicket(ticketId: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (isNullOrUndefined(ticketId) && !isNullOrUndefined(this.coTickets) && this.coTickets.length > 0) {
        this.storeSetCurrentTicket(this.coTickets[0]);
      }
    }, 100);

  }

  handleAddParticipant(channel) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.dtModalAddParticipantVisible = true;
      this.dtChannel = channel
    }, 100);
  }
}

export default TicketSideBarTicketGroups;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-sidebar-ticket-groups/index.ts